import useAlertGa4Tracking from './useAlertGa4Tracking';
import useAlertRumTracking from './useAlertRumTracking';

/**
 * Tracks alert display to both GA4 and Datadog RUM exactly once per mount, by
 * composing useAlertGa4Tracking and useAlertRumTracking. Apps that only need
 * one destination (e.g. VAOS already logs alert renders to Datadog via its own
 * useAlertTelemetry) can call those granular hooks directly instead.
 *
 * @param {Object}  options
 * @param {string}  options.headline   — alert headline text (GA4 `alert-box-headline`)
 * @param {string}  options.status     — 'error' | 'warning' | 'info' | 'success'
 * @param {string}  options.alertName  — human-readable identifier used in the RUM action name
 * @param {string}  [options.alertId]  — stable identifier independent of display copy; rides in
 *   the RUM context object and, if provided, as the GA4 param `alert-box-id`
 * @param {boolean} [options.isVisible=true] — whether the alert is currently rendered/visible
 * @param {Object}  [options.context={}] — free-form bag merged into the RUM action's context
 *   (e.g. `alertType`, `page`, `facilityId`, `recordType`). Not sent to GA4, since custom
 *   dimensions there require pre-registration.
 */
const useAlertTracking = ({
  headline,
  status,
  alertName,
  alertId,
  isVisible = true,
  context = {},
}) => {
  useAlertGa4Tracking({ headline, status, alertId, isVisible });
  // Combined tracking keeps its original contract: nothing fires unless a
  // headline is present, so gate the RUM half on headline too.
  useAlertRumTracking({
    alertName,
    status,
    alertId,
    isVisible: isVisible && !!headline,
    context,
  });
};

export default useAlertTracking;
